import css from 'styled-jsx/css';

export default css.global`.banner-dialog {
  position: fixed;
  bottom: 16px;
  left: 0;
  width: 100%;
  z-index: 2000;
}

.banner-container {
  background-color: #fff;
  margin: 0 2%;
  box-shadow: 0 1rem 3rem rgb(0 0 0 / 18%);
  padding: 5rem 3rem;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
}

.banner-container .img {
  width: 90px;
  margin: 2rem auto;
}

.banner-container .img img {
  width: 100%;
}

.banner-container p:nth-child(1) {
  color: #035e35;
  font-size: 2.5rem;
  font-weight: 700;
  line-height: 1.7;
}

.banner-container p:nth-child(2) {
  font-size: 16px;
  color: #76808b;
}

.banner-container p:nth-child(2) a {
  color: #035e35;
  text-decoration: underline;
}

.banner-container .cicod-btn {
  width: fit-content;
  margin-left: auto;
}

.actions {
  margin-top: 3rem;
}

.actions a:first-child {
  margin-right: 2rem;
}

.actions a:last-child {
  border: none;
  text-decoration: underline;
  font-size: 18px;
  font-weight: 500;
  color: #2f2e7c;
  cursor: pointer;
}

.actions a:last-child:hover {
  background-color: transparent !important;
}

@media (min-width: 1280px) {
  .banner-container {
    width: 1023px;
    margin: 0 auto;
    align-items: center;
    flex-direction: row;
    padding: 3rem;
  }

  .banner-container .img {
    width: 90px;
    margin-right: 5rem;
  }

  .banner-container .text {
    width: 70%;
    text-align: left;
    margin-right: 5rem;
  }

  .actions {
    min-width: max-content;
    margin-top: 0;
    margin-inline: auto;
  }
}
`